import type { OnboardingStep } from "@onboardjs/react";

export const SETUP_STEPS: OnboardingStep[] = [
	{
		id: "domain-discovery",
		type: "CUSTOM_COMPONENT",
		payload: {
			componentKey: "domain-discovery",
			title: "Company Setup",
			description:
				"Configure your organization domains and discover your firm's information.",
		},
		nextStep: "connect-email",
		// Only admins run org-level discovery
		condition: (context) => !!context.flowData.isAdmin,
	},
	{
		id: "connect-email",
		type: "CUSTOM_COMPONENT",
		payload: {
			componentKey: "connect-email",
			title: "Connect Email",
			description:
				"Connect your email account so Clerical can draft and manage messages on your behalf.",
		},
		previousStep: (context) =>
			context.flowData.isAdmin ? "domain-discovery" : null,
		nextStep: (context) => {
			// Members skip firm review entirely
			if (!context.flowData.isAdmin || context.flowData.firmProfileExists) {
				return "person-profile";
			}
			return "review-firm";
		},
	},
	{
		id: "review-firm",
		type: "CUSTOM_COMPONENT",
		payload: {
			componentKey: "review-firm",
			title: "Firm Profile",
			description:
				"Review and confirm your firm's profile and communication guidelines.",
		},
		previousStep: "connect-email",
		nextStep: "person-profile",
		// Only show for admins when firm profile doesn't exist yet
		condition: (context) =>
			!!context.flowData.isAdmin && !context.flowData.firmProfileExists,
	},
	{
		id: "person-profile",
		type: "CUSTOM_COMPONENT",
		payload: {
			componentKey: "person-profile",
			title: "Your Profile",
			description:
				"Review your personal profile, signature, and communication preferences.",
		},
		previousStep: (context) => {
			if (!context.flowData.isAdmin || context.flowData.firmProfileExists) {
				return "connect-email";
			}
			return "review-firm";
		},
		nextStep: null,
	},
];
